import { render, staticRenderFns } from "./DashboardWidgetSaveModal.vue?vue&type=template&id=7a04d470"
import script from "./DashboardWidgetSaveModal.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetSaveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports